import { CSSProperties, ReactElement } from 'react';

import { isMobile } from '../../utils/isMobile';

export const CustomRenderThumbView = ({ style, ...props }: { style: CSSProperties }): ReactElement => (
	<div {...props} style={{ ...style, overflow: isMobile ? 'auto' : 'scroll' }} />
);
